<template>
  <section>
    <el-table
      key="subscribers"
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="Monthly (Account Summary)">
        <template #default="{row}">
          <div class="flex-align-center">
            <span class="width-100 block mg-r-15">{{row.date}}</span>
            <span class="color-dark fw-600">{{row.count_credits|formatMoney(2, false)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template #default="{ row }">
          <span
            class="color-primary pointer"
            @click="exportCSV(row)"
          >
            <div class="export pointer">
              <!--              <font-awesome-icon-->
              <!--                icon="download"-->
              <!--                class="icon"></font-awesome-icon>-->
              Download
            </div>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getStatementList, getDownStatementList} from '@/api/account'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: '',
  mixins: [MixinOptions, MixinFormat],
  props:{
    customerId: [String, Number],
  },
  data () {
    return {
      tableData: [],
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
    }
  },
  watch: {
  },
  mounted(){
    this.getTabaleData()
  },
  methods: {
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    getTabaleData(params){
      this.network().getList(params)
    },
    exportCSV(item){
      let {export_date_y,export_date_m} = item||{}
      this.network().exportList({export_date_m,export_date_y,is_export:true})
    },
    network(){
      return{
        getList: async (params) =>{
          if(!this.customerId)return
          let { data } = await getStatementList({
            page: this.pageConfig.currentPage,
            customer_id:this.customerId
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },

        exportList: async (params) =>{
          if(!this.customerId)return
          let res = await getDownStatementList({...params, customer_id:this.customerId})
          downloadFile(res)
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/ .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  border-bottom: 0;
  th{
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    padding: 16px 10px;
    letter-spacing: -0.15px;
    color: #24292E!important;
    .cell{
      padding: 16px 10px;
    }
  }
  td{
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    .cell{
      height: 20px;
      line-height: 20px;
      padding: 0 15px;
    }
  }
}
.name{
  text-decoration: none;
  color: #0366D6;
}
.width-100{
  width: 100px;
}
</style>
